import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '~/util';
import {
    BADGE_SHEET_CELL_SIZE,
    type BadgeIconPosition,
} from '~/util/types/badges';

// awkward svg stuff cause css can't properly extract the right portion of the badges sheet without having to hardcode the sheet's dimensions here
// so instead svg viewbox gets specifically a BADGE_SHEET_CELL_SIZExBADGE_SHEET_CELL_SIZE area and that works smh idk don't ask me
export function BadgeIcon({
    badge,
    title,
    className,
    style,
    ...props
}: {
    badge: BadgeIconPosition;
    title?: string;
} & Omit<ComponentPropsWithoutRef<'svg'>, 'children'>) {
    return (
        <svg
            {...props}
            role={title ? 'img' : undefined}
            aria-label={title}
            viewBox={`0 0 ${BADGE_SHEET_CELL_SIZE} ${BADGE_SHEET_CELL_SIZE}`}
            className={cn('block', className)}
            style={style}
        >
            <image
                href="/assets/badge-icons/sheet.webp"
                x={-badge.iconColumn * BADGE_SHEET_CELL_SIZE}
                y={-badge.iconIndex * BADGE_SHEET_CELL_SIZE}
            />
        </svg>
    );
}
